import AddBoxIcon from '@mui/icons-material/AddBox';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import DisabledByDefaultRoundedIcon from '@mui/icons-material/DisabledByDefaultRounded';
import EditIcon from '@mui/icons-material/Edit';
import { ButtonBase, Stack, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
  variant: 'add' | 'delete' | 'trash' | 'close' | 'edit' | 'upward' | 'downward';
  text?: string;
  dense?: boolean;
  mt?: string;
  disabled?: boolean;

  action?(): void;
}

const PaiActionIconText: React.FC<Props> = ({ variant, text, dense, mt, disabled, action }) => {
  const { classes, cx } = useStyles({ dense });

  return (
    <ButtonBase className={cx(classes.button, variant)} onClick={action} disableRipple={true} disabled={disabled} sx={{ marginTop: mt }}>
      <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} gap={1}>
        {variant === 'delete' ? (
          <DisabledByDefaultRoundedIcon className={classes.icon} />
        ) : variant === 'trash' ? (
          <DeleteIcon className={classes.icon} />
        ) : variant === 'close' ? (
          <CloseIcon className={classes.icon} />
        ) : variant === 'add' ? (
          <AddBoxIcon className={classes.icon} />
        ) : variant === 'edit' ? (
          <EditIcon className={classes.icon} />
        ) : variant === 'upward' ? (
          <ArrowUpwardIcon className={classes.icon} />
        ) : variant === 'downward' ? (
          <ArrowDownwardIcon className={classes.icon} />
        ) : null}
        {!_.isNil(text) ? <Typography className={classes.text}>{text}</Typography> : null}
      </Stack>
    </ButtonBase>
  );
};

const useStyles = makeStyles<{ dense?: boolean }>()((theme, { dense }) => ({
  button: {
    width: 'fit-content',
    '&.delete': {
      color: theme.palette.error.main,
    },
    '&.trash': {
      color: theme.palette.greys.medium,
    },
    '&.close': {
      color: theme.palette.primary.main,
    },
    '&.add': {
      color: theme.palette.primary.main,
    },
    '&.edit': {
      color: theme.palette.primary.main,
    },
    '&.upward': {
      color: theme.palette.greys.medium,
    },
    '&.downward': {
      color: theme.palette.greys.medium,
    },
    '&:hover': {
      color: theme.palette.secondary.main,
      '&.trash': {
        color: theme.palette.error.main,
      },
    },
    '&.Mui-disabled': {
      color: theme.palette.action.disabled,
    },
  },
  icon: {
    fontSize: theme.typography.pxToRem(!dense ? 20 : 16),
  },
  text: {
    fontSize: theme.typography.pxToRem(!dense ? 13 : 11),
    textDecoration: 'underline',
    textUnderlineOffset: '4px',
  },
}));

export default PaiActionIconText;
